(function (themeCurrency) {
  const locale = document.documentElement.lang;
  const wrapper = document.querySelector('[data-section-type="product"]');
  const addBtn = wrapper.querySelector('[data-add-to-cart]');
  const currentVariantId = wrapper.querySelector('input[name="id"]');
  const cycleDiscount = wrapper.getAttribute("data-selling-plan");
  const productJson = JSON.parse(wrapper.querySelector('[data-product-json]').innerHTML);

  const discountEligible = wrapper.dataset.discountEligible;
  const customerDiscount = wrapper.dataset.customerDiscount;

  const applyDiscount = (price, discount) => (price * (1 - discount));

  var foundKit = null;

  document.addEventListener("DOMContentLoaded", function () {
    var id = parseFloat(currentVariantId.value);
    var foundVariant = productJson.variants.find((item) => item.id === id);
    if (!foundVariant) return;

    var widgetRendered = setInterval(() => {
      if (wrapper.querySelector('.rc-widget')) {
        clearInterval(widgetRendered);
        configureInputs();
        configureTextLabels();
        configureSellingPlanOptions();

        if (discountEligible && customerDiscount > 0) {
          configureConsultantPrice(foundVariant);
        } else {
          configurePrice(foundVariant);
        }

        if (isConsultant) {
          hideSubscriptionButton();
        }
      }
    }, 100);
  });

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;
    if (!cart) return;
    foundKit = cart.items.find((item) => item.product_type === 'Kit');
    configureAddButton();
  });

  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail.variant;
    configurePrice(variant);
  });

  function setDeliveryPeriodSelector(){
    const deliveryPeriodSelector = document.querySelector(".rc-selling-plans-dropdown__select");
    if (!deliveryPeriodSelector) return;
    const sellingPlanOptions = deliveryPeriodSelector.getElementsByTagName('option');
    if (!sellingPlanOptions.length) return;
    const sellingPlanOptionsArr = Array.from(sellingPlanOptions);
    const consultantOnlyOptions = sellingPlanOptionsArr.filter((option) => option.textContent.includes('Jafra Insider subscription'));
    const nonConsultantOnlyOptions = sellingPlanOptionsArr.filter((option) => !option.textContent.includes('Jafra Insider subscription'));
    const sellingPlanInput = wrapper.querySelector('input[name="selling_plan"]');

    if (locale === "es") {
      nonConsultantOnlyOptions.forEach((option) => {
        const esLocaleText = "Enviar y cobrar cada 30 días";
        if (option.textContent.includes('30')) {
          option.textContent = esLocaleText;
        }
        if (option.textContent.includes('60')) {
          option.textContent = esLocaleText.replace('30', '60');
        }
        if (option.textContent.includes('90')) {
          option.textContent = esLocaleText.replace('30', '90');
        }
      });
    }

    if (isConsultant) {
      sellingPlanInput.value = consultantOnlyOptions[0].value;
      deliveryPeriodSelector.value = consultantOnlyOptions[0].value;
      nonConsultantOnlyOptions.forEach((option) => option.classList.add("hide"));
      
    } else {
      sellingPlanInput.value = nonConsultantOnlyOptions[0].value;
      deliveryPeriodSelector.value = nonConsultantOnlyOptions[0].value;
      consultantOnlyOptions.forEach((option) => option.classList.add("hide"));
    }
    const firstOption = deliveryPeriodSelector.getElementsByTagName("option")[0];
    const defaultOption = document.createElement("option");
    defaultOption.value = "0";
    defaultOption.textContent = locale === "es" ? "Elige la Frecuencia de Suscripción y Pago" : "Select Subscription and Payment Frequency";
    deliveryPeriodSelector.insertBefore(defaultOption, firstOption);
    deliveryPeriodSelector.value = "0";
    
    addBtn.setAttribute("data-disabled-flag", "disabled");
    addBtn.classList.add("disabled");
    addBtn.disabled = true;
    deliveryPeriodSelector.addEventListener("change", function() {
      if (deliveryPeriodSelector.value === "0") {
        addBtn.setAttribute("data-disabled-flag", "disabled");
        addBtn.classList.add("disabled");
        addBtn.disabled = true;
      } else {
        addBtn.removeAttribute("data-disabled-flag");
        addBtn.classList.remove("disabled");
        addBtn.disabled = false;
      }
    });
  }

  function configureAddButton() {
    const widget = wrapper.querySelector('.rc-widget');
    if (!widget) return;

    const subscriptionInput = widget.querySelector('input[value="subscription"]');
    if (foundKit && subscriptionInput.checked) {
      addBtn.setAttribute("data-disabled-flag", "disabled");
      addBtn.classList.add("disabled");
      addBtn.disabled = true;
      setDeliveryPeriodSelector();
    } else {
      const deliveryPeriodSelector = document.querySelector(".rc-selling-plans-dropdown__select");
      if (deliveryPeriodSelector && deliveryPeriodSelector.value === "0") return;
      addBtn.removeAttribute("data-disabled-flag");
      addBtn.classList.remove("disabled");
      addBtn.disabled = false;
    }
  }

  function configureInputs() {
    const widget = wrapper.querySelector('.rc-widget');
    if (!widget) return;
    const inputs = widget.querySelectorAll('input[name="purchaseOption"]');
    
    inputs.forEach((input) => {
      input.addEventListener("change", configureAddButton);
    });
  }

  function configureTextLabels() {
    const widget = wrapper.querySelector('.rc-widget');
    if (!widget) return;
    
    const oneTimePurchaseLabelText = widget.querySelector('.onetime-radio .discount-label');
    const subscriptionLabelText = widget.querySelector('.subscription-radio .discount-label');

    widget.style.cssText = `--rc-subscription-sub-label: '${window.theme.strings.rcSubscription.subscriptionSubLabel}';`;
    if (oneTimePurchaseLabelText) oneTimePurchaseLabelText.textContent = window.theme.strings.rcSubscription.oneTimePurchaseLabel;
    if (subscriptionLabelText) subscriptionLabelText.textContent = window.theme.strings.rcSubscription.subscriptionLabel;
  }

  function configureSellingPlanOptions() {
    const widget = wrapper.querySelector('.rc-widget');
    if (!widget) return;

    const subscriptionInput = widget.querySelector('input[value="subscription"]');
   
    setDeliveryPeriodSelector();
    subscriptionInput.addEventListener('change', function() {
      setDeliveryPeriodSelector();
    })
  }

  function configurePrice(variant) {
    const widget = wrapper.querySelector('.rc-widget');
    if (!widget) return;

    const oneTimePurchaseLabel = widget.querySelector('.onetime-radio .rc-radio__label');

    if (variant.compare_at_price > variant.price) {
      oneTimePurchaseLabel.classList.add('js');
      oneTimePurchaseLabel.innerHTML = `
        <span class="discount-label">One Time Purchase</span>
        <span class="price-label">
          <span class="product__price--sale">${themeCurrency.formatMoney(variant.price, theme.moneyFormat)}</span>
          <span class="product__price--compare">${themeCurrency.formatMoney(variant.compare_at_price, theme.moneyFormat)}</span>
        </span>
      `;
    }
  }

  // Functions to handle consultant pricing
  const setRechargeSubscribePrice = (subscribePriceEl, price, cycleDiscount) => {
    if (isConsultant) {
      subscribePriceEl.innerText = themeCurrency.formatMoney(price, theme.moneyFormat);
    } else {
      const subscribePrice = applyDiscount(price, cycleDiscount);
      subscribePriceEl.innerText = themeCurrency.formatMoney(subscribePrice, theme.moneyFormat);
    }
  }

  // Variables to prevent infinite loops
  const maxAttempts = 4;
  let attempts = 0;
  let listenerAttached = false;

  const setRechargeSelectCycle = (subscribePriceEl) => {
    setTimeout(() => {
      const deliveryPeriodSelector = document.querySelector(".rc-selling-plans-dropdown__select");

      if (deliveryPeriodSelector && subscribePriceEl && !listenerAttached) {
        deliveryPeriodSelector.addEventListener("change", (event) => {
          
          if(deliveryPeriodSelector.value === "0") {
            addBtn.setAttribute("data-disabled-flag", "disabled");
            addBtn.classList.add("disabled");
            addBtn.disabled = true;
          } else {
            addBtn.removeAttribute("data-disabled-flag");
            addBtn.classList.remove("disabled");
            addBtn.disabled = false;
          }
          const currentVariantIdValue = parseFloat(currentVariantId.value);
          const currentVariant = productJson.variants.find((item) => item.id === currentVariantIdValue);
          const price = applyDiscount(currentVariant.price, customerDiscount);
          const cycleDiscount = productSellingPlans[event.target.value];
          setRechargeSubscribePrice(subscribePriceEl, price, cycleDiscount);
        })
        listenerAttached = true;
      } else if(attempts < maxAttempts) {
        setTimeout(() => setRechargeSelectCycle(subscribePriceEl), 200);
        attempts += 1;
      }
    }, 100);
  }

  function configureConsultantPrice(variant) {
    const widget = wrapper.querySelector('.rc-widget');
    if (!widget) return;

    const oneTimePurchaseButton = widget.querySelector('.onetime-radio');
    const oneTimePurchaseLabel = widget.querySelector('.onetime-radio .rc-radio__label');
    const subscriptionPurchaseButton = widget.querySelector('.subscription-radio');
    const subscriptionPurchaseLabel = widget.querySelector('.subscription-radio .rc-radio__label');

    const oneTimePrice = applyDiscount(variant.price, customerDiscount);

    oneTimePurchaseLabel.classList.add('js');
    oneTimePurchaseLabel.innerHTML = `
      <span class="discount-label">${window.theme.strings.rcSubscription.oneTimePurchaseLabel}</span>
      <span class="price-label">
        <span class="label">${variant.compare_at_price > variant.price ? window.theme.strings.rcSubscription.salePriceLabel : window.theme.strings.rcSubscription.retailPriceLabel}&colon;</span>
        <span data-product-price>${themeCurrency.formatMoney(variant.price, theme.moneyFormat)}</span>
      </span>
      <span class="price-label">
        <span class="label">${window.theme.strings.rcSubscription.commissionPriceLabel}&colon;</span>
        <span data-final-price class="product__price--sale">${themeCurrency.formatMoney(oneTimePrice, theme.moneyFormat)}</span>
      </span>
    `;

    subscriptionPurchaseLabel.classList.add('js');
    subscriptionPurchaseLabel.innerHTML = `
      <span class="discount-label">${window.theme.strings.rcSubscription.subscriptionLabel}</span>
      <span class="price-label">
        <span class="label">${variant.compare_at_price > variant.price ? window.theme.strings.rcSubscription.salePriceLabel : window.theme.strings.rcSubscription.retailPriceLabel}&colon;</span>
        <span data-product-price>${themeCurrency.formatMoney(variant.price, theme.moneyFormat)}</span>
      </span>
      <span class="price-label">
        <span class="label">${window.theme.strings.rcSubscription.commissionPriceLabel}&colon;</span>
        <span data-final-price class="product__price--sale">${themeCurrency.formatMoney(oneTimePrice, theme.moneyFormat)}</span>
      </span>
    `;

    const subscriptionPurchasePriceLabel = widget.querySelector('.subscription-radio [data-final-price]');

    setRechargeSubscribePrice(subscriptionPurchasePriceLabel, oneTimePrice, cycleDiscount);
    setRechargeSelectCycle(subscriptionPurchasePriceLabel);

    oneTimePurchaseButton.addEventListener("click", () => {
      setTimeout(() => {
        const currentVariantIdValue = parseFloat(currentVariantId.value);
        const currentVariant = productJson.variants.find((item) => item.id === currentVariantIdValue);
        const price = applyDiscount(currentVariant.price, customerDiscount);
        setRechargeSubscribePrice(subscriptionPurchasePriceLabel, price, cycleDiscount);
      }, 300);
    });

    subscriptionPurchaseButton.addEventListener("click", () => {
      setRechargeSelectCycle(subscriptionPurchasePriceLabel);
    });
  }

  function hideSubscriptionButton() {
    const widget = wrapper.querySelector('.rc-widget');
    if (!widget) return;

    const subscriptionButton = widget.querySelector('.rc-radio.subscription-radio');
    if (subscriptionButton) subscriptionButton.classList.add('hide');
  }
})(themeVendor.themeCurrency);